import { action, makeObservable } from "mobx";
import {ServiceBase} from "../ServiceBase";
import {IMenuFlowService} from "./menu-flow.service.interface";
import {CustomFlowAction, CustomFlowResult} from "./interfaces";
import {AppIdentifiers, AreaType, ChatOpenMode} from '@sparkware/uc-sdk-core';
import {IServiceFactoryExtended} from "../service-factory-extended.interface";

export class MenuFlowService extends ServiceBase implements IMenuFlowService {

  constructor(services: IServiceFactoryExtended) {
    super(services);

    makeObservable(this);
  }

  private customFlows: {
    [key: string]: CustomFlowAction
  } = {
	  "PWA_ADD_TO_HOME_SCREEN": this._executeInstallPwa.bind(this),
      "LIVE_CHAT": this._openProactiveChat.bind(this),
  };



  hasCustomFlow<T extends {text: string}>(menuItem: T) {
    if(menuItem.text === 'LIVE_CHAT') {
      if (this.services.language.isRTLLanguage) {
        return false;
      }
      return this.services.configuration.servicesConfigs.AppLauncher.apps.CR_CHAT.enabled;
    }
    return menuItem.text in this.customFlows;
  }

  executeCustomFlow<T extends {text: string}>(menuItem?: T) {
    const textKey = menuItem.text;
    if(textKey in this.customFlows) {
      return this.customFlows[textKey](menuItem);
    }

    return {continue: true};
  }

  private _openProactiveChat(): CustomFlowResult {
    this.services.userMenu.closeMenu();
    this.services.sideMenu.closeMobileMenu();
    this.services.appLauncher.openChat( {
      businessCorrelationID: this.services.tools.getGuid(),
      appSpecificParameters: {
        openMode: ChatOpenMode.Chat,
      },
      channel: {
        area: AreaType.NavigationMenu,
        element: 'live_chat',
        source: AppIdentifiers.CasinoClient
      }
    });
    return {continue: false};
  }

  private _executeInstallPwa(): CustomFlowResult {
    this.services.progressiveWebApp.prompt();
    return {continue: false};
  }

  @action.bound
  promptPushNotificationPermissionRequest() {
    this.services.sdk.promptPushNotificationPermissionRequest();
  }
}
